import { render, staticRenderFns } from "./SlideConfirmButton.vue?vue&type=template&id=24c60bd4&scoped=true&"
import script from "./SlideConfirmButton.vue?vue&type=script&lang=ts&"
export * from "./SlideConfirmButton.vue?vue&type=script&lang=ts&"
import style0 from "./SlideConfirmButton.vue?vue&type=style&index=0&id=24c60bd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c60bd4",
  null
  
)

export default component.exports